import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, observable } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';

//import pckg from '../../package.json';

import { MatDialog, MatTabBodyPortal } from '@angular/material';
import { PopupComponent } from '../app/popup/popup.component';
import { FormArray, FormGroup } from '@angular/forms';

import * as FileSaver from 'file-saver';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpOptionsPACDigiFact = {
  headers: new HttpHeaders().set('Content-Type', 'text/xml'),
  responseType: 'text'
};

@Injectable({
  providedIn: 'root'
})
export class DataService {

 //>> PROD CSI   > '201.1.1.1'
 private myHost = this.infoHostClient();
 private myPort = '6008';      
 private defaultMyPort = this.myPort;
 private urlSysVer = 'http://' + this.myHost + ':' + this.myPort + '/sys/ver';

 private urlUploadFile3 = 'http://' + this.myHost + ':' + this.myPort + '/upload3';
 private urlUploadFileDoc = 'http://' + this.myHost + ':' + this.myPort + '/uploadDocs';
 private urlMySQLsetLocale = 'http://' + this.myHost + ':' + this.myPort + '/sql/setLocale';
 private urlMySQLshowTableStatus = 'http://' + this.myHost + ':' + this.myPort + '/sql/showTableStatus';
 private urlMySQLcheckTable = 'http://' + this.myHost + ':' + this.myPort + '/sql/checkTable';
 private urlMySQLoptimizeTable = 'http://' + this.myHost + ':' + this.myPort + '/sql/optimizeTable';
 private urlMySQLrepairTable = 'http://' + this.myHost + ':' + this.myPort + '/sql/repairTable';
 private urlMySQLbackupTable = 'http://' + this.myHost + ':' + this.myPort + '/sql/backupTable';
 private urlMySQLshowWarnings = 'http://' + this.myHost + ':' + this.myPort + '/sql/showWarnings';
 private urlMySQLshowErrors = 'http://' + this.myHost + ':' + this.myPort + '/sql/showErrors';
 private urlMySQLsizeDB = 'http://' + this.myHost + ':' + this.myPort + '/sql/sizeDB';
 private urlMySQLbackDB = 'http://' + this.myHost + ':' + this.myPort + '/sql/backDB';
 private urlMySQLmaxCnn = 'http://' + this.myHost + ':' + this.myPort + '/sql/maxCnn';
 private urlMySQLhilos = 'http://' + this.myHost + ':' + this.myPort + '/sql/hilos';
 private urlMySQLflushHosts = 'http://' + this.myHost + ':' + this.myPort + '/sql/flushHosts';
 private urlMySQLflushLogs = 'http://' + this.myHost + ':' + this.myPort + '/sql/flushLogs';
 
 private urlAlive = 'http://' + this.myHost + ':' + this.myPort + '/xp/alive';
 private urlG = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysg';
 private urlMail = 'http://' + this.myHost + ':' + this.myPort + '/xp/sysmail';
 private urlMailRec = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailrec';
 private urlMailPba = 'http://' + this.myHost + ':' + this.myPort + '/xp/mailpba';
 private urlMailLog = 'http://' + this.myHost + ':' + this.myPort + '/xp/maillog';
 private urlMenu = 'http://' + this.myHost + ':' + this.myPort + '/xp/menu';
 private urlMenu2 = 'http://' + this.myHost + ':' + this.myPort + '/xp/menu2';
 private urlMenUser = 'http://' + this.myHost + ':' + this.myPort + '/xp/menUser';
 private urlAutMenu = 'http://' + this.myHost + ':' + this.myPort + '/xp/autMenu';
 private urlAccXcep = 'http://' + this.myHost + ':' + this.myPort + '/xp/rolXcep';
 private urlGetVars = 'http://' + this.myHost + ':' + this.myPort + '/xp/vars';
 private urlSetVar = 'http://' + this.myHost + ':' + this.myPort + '/xp/updVar';
 private urlGetVarsUnidad = 'http://' + this.myHost + ':' + this.myPort + '/xp/varsUnidad';
 private urlSetVarUnidad = 'http://' + this.myHost + ':' + this.myPort + '/xp/updVarUnidad';
 private urlUltFolio = 'http://' + this.myHost + ':' + this.myPort + '/xp/ultFolio';
 private urlGetFechaEspecial = 'http://' + this.myHost + ':' + this.myPort + '/xp/fechaEspecial';
 private urlAltaFechaEspecial = 'http://' + this.myHost + ':' + this.myPort + '/xp/altaFechaEsp';
 private urlBajaFechaEspecial = 'http://' + this.myHost + ':' + this.myPort + '/xp/bajaFechaEsp';
 private urlGetEnvioLog = 'http://' + this.myHost + ':' + this.myPort + '/xp/envioLog';
 private urlAltaEnvioLog = 'http://' + this.myHost + ':' + this.myPort + '/xp/altaEnvioLog';
 private urlBajaEnvioLog = 'http://' + this.myHost + ':' + this.myPort + '/xp/bajaEnvioLog';
 private urlLogin = 'http://' + this.myHost + ':' + this.myPort + '/xp/login';
 private urlUsrExist = 'http://' + this.myHost + ':' + this.myPort + '/xp/usrExist'; 
 private urlLog = 'http://' + this.myHost + ':' + this.myPort + '/xp/log';
 private urlFormatoImp = 'http://' + this.myHost + ':' + this.myPort + '/xp/formatoImp';
 private urlFormStyles = 'http://' + this.myHost + ':' + this.myPort + '/xp/formatoStyles';
 private urlElemFormatoImp = 'http://' + this.myHost + ':' + this.myPort + '/xp/elemFormImp';
 
 
 private urlProdAct = 'http://' + this.myHost + ':' + this.myPort + '/xp/prodAct';
 private urlDescAct = 'http://' + this.myHost + ':' + this.myPort + '/xp/descAct';
 private urlFormAct = 'http://' + this.myHost + ':' + this.myPort + '/xp/formAct';
 private urlIsFormaDup = 'http://' + this.myHost + ':' + this.myPort + '/xp/isFormaDup';
 private urlProductos = 'http://' + this.myHost + ':' + this.myPort + '/xp/productos';
 private urlUpdProducto = 'http://' + this.myHost + ':' + this.myPort + '/xp/updProducto';
 private urlInsProducto = 'http://' + this.myHost + ':' + this.myPort + '/xp/insProducto';
 private urlInsRestoProducto = 'http://' + this.myHost + ':' + this.myPort + '/xp/insProductoResto';
 private urlIsProductoDup = 'http://' + this.myHost + ':' + this.myPort + '/xp/isProductoDup';
 private urlDescuentos = 'http://' + this.myHost + ':' + this.myPort + '/xp/descuentos';
 private urlIsDescuentoDup = 'http://' + this.myHost + ':' + this.myPort + '/xp/isDescuentoDup';
 private urlExposiciones = 'http://' + this.myHost + ':' + this.myPort + '/xp/exposiciones';
 private urlUpdDescuento = 'http://' + this.myHost + ':' + this.myPort + '/xp/updDescuento';
 private urlInsDescuento = 'http://' + this.myHost + ':' + this.myPort + '/xp/insDescuento';
 private urlCategorias = 'http://' + this.myHost + ':' + this.myPort + '/xp/categorias';
 private urlUpdCategoria = 'http://' + this.myHost + ':' + this.myPort + '/xp/updCategoria';
 private urlInsCategoria = 'http://' + this.myHost + ':' + this.myPort + '/xp/insCategoria';
 private urlGrupos = 'http://' + this.myHost + ':' + this.myPort + '/xp/grupos';
 private urlTipos = 'http://' + this.myHost + ':' + this.myPort + '/xp/tipos';
 private urlRoles = 'http://' + this.myHost + ':' + this.myPort + '/xp/roles';
 private urlRoles2 = 'http://' + this.myHost + ':' + this.myPort + '/xp/roles2';
 private urlMonedas = 'http://' + this.myHost + ':' + this.myPort + '/xp/monedas';
 private urlUpdMoneda = 'http://' + this.myHost + ':' + this.myPort + '/xp/updMoneda';
 private urlInsMoneda = 'http://' + this.myHost + ':' + this.myPort + '/xp/insMoneda';
 private urlFormas = 'http://' + this.myHost + ':' + this.myPort + '/xp/formas';
 private urlUpdForma = 'http://' + this.myHost + ':' + this.myPort + '/xp/updForma';
 private urlInsForma = 'http://' + this.myHost + ':' + this.myPort + '/xp/insForma';
 private urlUbicaciones = 'http://' + this.myHost + ':' + this.myPort + '/xp/ubicaciones';
 private urlUsuarios = 'http://' + this.myHost + ':' + this.myPort + '/xp/usuarios';
 private urlUpdUsuario = 'http://' + this.myHost + ':' + this.myPort + '/xp/updUsuario';
 private urlInsUsuario = 'http://' + this.myHost + ':' + this.myPort + '/xp/insUsuario';
 private urlIsUsuarioDup = 'http://' + this.myHost + ':' + this.myPort + '/xp/isUsuarioDup';
 private urlIsSameUsuarioPwd = 'http://' + this.myHost + ':' + this.myPort + '/xp/isSameUsuarioPwd';
 private urlUpdUsuarioPwd = 'http://' + this.myHost + ':' + this.myPort + '/xp/updUsuarioPwd';
 private urlUsrsAdmon = 'http://' + this.myHost + ':' + this.myPort + '/xp/usuariosAdmon';
 private urlInsTicket = 'http://' + this.myHost + ':' + this.myPort + '/xp/insTicket';
 private urlInsTicketIngreso = 'http://' + this.myHost + ':' + this.myPort + '/xp/insTicketIngreso';
 private urlCanTicket = 'http://' + this.myHost + ':' + this.myPort + '/xp/canTicket';
 private urlCanTickets = 'http://' + this.myHost + ':' + this.myPort + '/xp/canTickets';
 private urlUpdTicket = 'http://' + this.myHost + ':' + this.myPort + '/xp/updTicket';
 private urlUpdTickets = 'http://' + this.myHost + ':' + this.myPort + '/xp/updTickets';
 private urlInsEstadisticos = 'http://' + this.myHost + ':' + this.myPort + '/xp/insEstadisticos';
 private urlUltimosTickets = 'http://' + this.myHost + ':' + this.myPort + '/xp/ultTickets';
 private urlUltimosTicketsGpo = 'http://' + this.myHost + ':' + this.myPort + '/xp/ultTicketsGpo';
 private urlNotaVenta = 'http://' + this.myHost + ':' + this.myPort + '/xp/notaVenta';
 private urlNotaVentaGpo = 'http://' + this.myHost + ':' + this.myPort + '/xp/notaVentaGpo';
 private urlCancelaciones = 'http://' + this.myHost + ':' + this.myPort + '/xp/cancelaciones';
 private urlAfluencia = 'http://' + this.myHost + ':' + this.myPort + '/xp/afluencia';
 private urlRepIngreso = 'http://' + this.myHost + ':' + this.myPort + '/xp/repIngreso';
 private urlRepIngresoDet = 'http://' + this.myHost + ':' + this.myPort + '/xp/repIngresoDet';
 private urlInfoReciboOrigen = 'http://' + this.myHost + ':' + this.myPort + '/xp/infoReciboOrigen';
 private urlMeta = 'http://' + this.myHost + ':' + this.myPort + '/xp/meta';
 private urlUpdMeta = 'http://' + this.myHost + ':' + this.myPort + '/xp/updMeta';
 private urlInsMeta = 'http://' + this.myHost + ':' + this.myPort + '/xp/insMeta';
 private urlSISC = 'http://' + this.myHost + ':' + this.myPort + '/xp/sisc';
 private urlSISCDiario = 'http://' + this.myHost + ':' + this.myPort + '/xp/siscDiario';
 private urlSISC2 = 'http://' + this.myHost + ':' + this.myPort + '/xp/sisc2';
 private urlJefe = 'http://' + this.myHost + ':' + this.myPort + '/xp/jefe';
 private urlExisteUsrJefe = 'http://' + this.myHost + ':' + this.myPort + '/xp/existeUsrJefe';
 private urlCorte = 'http://' + this.myHost + ':' + this.myPort + '/xp/corte';
 private urlArqueo = 'http://' + this.myHost + ':' + this.myPort + '/xp/arqueo';
 private urlDestinatario = 'http://' + this.myHost + ':' + this.myPort + '/xp/destinatario';
 private urlOrigenes = 'http://' + this.myHost + ':' + this.myPort + '/xp/origenes';
 private urlInsRecibo = 'http://' + this.myHost + ':' + this.myPort + '/xp/insRecibo';

 private urlValidaFolio = 'http://' + this.myHost + ':' + this.myPort + '/xp/validaFolio'; 
 private urlInsEntradaUbi = 'http://' + this.myHost + ':' + this.myPort + '/xp/insEntradaUbi';
 private urlEntradasDia = 'http://' + this.myHost + ':' + this.myPort + '/xp/entradasDia';
 private urlEntradasMes = 'http://' + this.myHost + ':' + this.myPort + '/xp/entradasMes';
 private urlEntradasDiaSem = 'http://' + this.myHost + ':' + this.myPort + '/xp/entradasDiaSem';
 private urlEntradasHorario = 'http://' + this.myHost + ':' + this.myPort + '/xp/entradasHorario';
 private urlVentasDia = 'http://' + this.myHost + ':' + this.myPort + '/xp/ventasDia';
 private urlVentasMes = 'http://' + this.myHost + ':' + this.myPort + '/xp/ventasMes';
 private urlVentasDiaSem = 'http://' + this.myHost + ':' + this.myPort + '/xp/ventasDiaSem';
 private urlVentasHorario = 'http://' + this.myHost + ':' + this.myPort + '/xp/ventasHorario';

 private urlPres_Arbol = 'http://' + this.myHost + ':' + this.myPort + '/xp/presArbol';
 private urlIsConceptoDup = 'http://' + this.myHost + ':' + this.myPort + '/xp/isConceptoDup';
 private urlUpdConcepto = 'http://' + this.myHost + ':' + this.myPort + '/xp/updConcepto';
 private urlInsConcpeto = 'http://' + this.myHost + ':' + this.myPort + '/xp/insConcepto';
 private urlPres_UltMov = 'http://' + this.myHost + ':' + this.myPort + '/xp/presUltMov';
 private urlInsPres_Mov = 'http://' + this.myHost + ':' + this.myPort + '/xp/insPresMov';
 private urlPres_Totales = 'http://' + this.myHost + ':' + this.myPort + '/xp/presTotales';
 
 private urlInsNotaVenta = 'http://' + this.myHost + ':' + this.myPort + '/xp/insNotaVenta';
 private urlUpdTicketNV = 'http://' + this.myHost + ':' + this.myPort + '/xp/updTicketNV';
 private urlMaxFolioSAE = 'http://' + this.myHost + ':' + this.myPort + '/xp/maxFolioSAE';

 private urlFileExists = 'http://' + this.myHost + ':' + this.myPort + '/xp/fileExists';
 private urlTabla = 'http://' + this.myHost + ':' + this.myPort + '/xp/tabla';
 private urlInsEvAudioIARegistro = 'http://' + this.myHost + ':' + this.myPort + '/xp/insEvAudioIARegistro';
 private url_CF_InsEvAudioIARegistro = 'https://' + this.myHost + '/db_select';
   
 public sN:string = "ACSI";
 public sWe:string = "";
 public sM:string = "";
 public sT1:string = "";
 public sT2:string = "";
 public sWa:string = "";
 public sDe:string = "ANTIGUO COLEGIO DE SAN ILDEFONSO";
 public sRFC:string = "XAXX000000AAA";
 public sIP:string = "";
 public sDi:string = "";
 public sDi2:string = "";
 public sCP:string = "";
 public sTerr:number = 2100;
 public sMailHost = "";
 public sMailFrom = "";
 public sMailU = "";
 public sMailP = "";
 public sMailSSL = "";
 public sMailTSL = "";
 public iteracionWSS;
 public iteracionDisp;
 public navegador;
 public IVA:number=0.16;


  constructor(   private http: HttpClient, public dialog: MatDialog) { }

  infoVer(){
    //return pckg.version;   
    //console.log(this.myHost.toString()); 
    const metas = document.getElementsByTagName('meta');
    var aux = "?";
    //console.log("infoVer()");
    //console.log(metas);
    for (let i = 0; i < metas.length; i++) {
      //console.log(metas[i]);
      if (metas[i].getAttribute('property') === "keywords") {
        aux = metas[i].getAttribute('content');
        i = 999;
      }
    }
    if(aux.toUpperCase().indexOf(".PRE") > 0){    //--> AMBIENTE PRUEBAS! (leido de version de index.html)
     this.myPort = '5008';  
     this.fnRecargaURLs();
    }
    return aux.toUpperCase().replace("VERSION=","");
  }
 
  fnRecargaURLs(){
   let array = Object.getOwnPropertyNames(this);
   for(var i = 0; i < array.length; i++){    
     if(array[i].substring(0,3) == "url"){
       //console.log(array[i]);
       //console.log(this[array[i]]);
       this[array[i]] = this[array[i]].replace(this.defaultMyPort, this.myPort);
     }
   }
  }
 
  infoApp(){
   //console.log(">><><><><><><><><><><><><><><><><><><><><><><><><><><><><<")  
   //console.log(pckg.friendlyname + " (" + pckg.name + ")  ver." + pckg.version);
   //console.log("IP servicio: " + this.myHost + ":" + this.myPort);
   //console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
   //console.log("Desarrollador: "  + pckg.developer + "       « " + pckg.mail + " »");
   //console.log("  " + pckg.copyright);  
   //console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")   
   console.log(">><><><><><><><><><><><><><><><><><><><><><><><><><><><><<")  
   console.log("CSI-BILL" + " (" + "tickets" + ")  ver." + this.infoVer());
   console.log("IP servicio: " + this.myHost + ":" + this.myPort);
   console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
   console.log("Desarrollador: "  + "Fabián Orozco" + "       « " + "orozco.f@gmail.com" + " »");
   console.log("            " + "® Copyright 2024 ~ Oro'z Co.");  
   console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")   
  } 
 
  infoHostClient(){
    var url = document.location.href;
    //console.log(url);
    var prehost = url.substr(url.indexOf("://") + 3); 
    var host = prehost.substr(0, prehost.indexOf("/"));
    if(host.indexOf(":") > 0)
     host = host.substr(0, host.indexOf(":"));
    return host;
  }
 
  infoHostPortClient(){
   var url = document.location.href;
   //console.log(url);
   var prehost = url.substr(url.indexOf("://") + 3); 
   var hostport = prehost.substr(0, prehost.indexOf("/"));
   return hostport;
  }
 
  infoWebClient(){
   //console.log("window.navigator.userAgent");
   //console.log(window.navigator.userAgent);
   var nav = window.navigator.userAgent.toUpperCase();
   var ver = "?";
   if(nav.indexOf("EDGE/")>0){
     ver = this.encuentraVersion(nav.substr(nav.indexOf("EDGE/") + 5));
     this.navegador = {name: "EDGE", code:"ED", ver: ver};
   }
   else{
     if(nav.indexOf("CHROME/")>0){
       ver = this.encuentraVersion(nav.substr(nav.indexOf("CHROME/") + 7));
       this.navegador = {name: "CHROME", code:"CH", ver:ver};
     }
     else{
       if(nav.indexOf("FIREFOX/")>0){
         ver = this.encuentraVersion(nav.substr(nav.indexOf("FIREFOX/") + 8));
         this.navegador = {name: "FIREFOX", code:"FF", ver:ver};
       }
       else{
         if(nav.indexOf("SAFARI/")>0){
           ver = this.encuentraVersion(nav.substr(nav.indexOf("VERSION/") + 8));
           this.navegador = {name: "SAFARI", code:"SA", ver:ver};
         }
         else{
           ver = this.encuentraVersion(nav.substr(nav.indexOf("RV:") + 3));
           this.navegador = {name: "IE U OTRO", code:"IE", ver:ver};
         }
       }
     }
   }
   console.log("Usando navegador: " + this.navegador.name + " v." + this.navegador.ver);
   if (this.navegador.code == "IE" ){
     this.fnAvisoNoSoportado();         
   }
   else{
     if(this.navegador.code != "CH" ){
       //this.fnAvisoRecomendacion();   --> NO MOSTRAR RECOMENDACIÓN!
     }
   }
  }
 
  encuentraVersion(str){
   var fin, fin2, fin3 = 9999;
   var min = 0;
   fin = str.indexOf(";");
   fin2 = str.indexOf(" ");
   fin3 = str.indexOf(")");
   if(fin < 0)
     fin = 9999;
   if(fin2 < 0)
     fin2 = 9999;
   if(fin3 < 0)
     fin3 = 9999;
   if (fin == 9999  && fin2 == 9999 && fin3 == 9999)
     return str;
   else{
     min = fin;
     if(fin2 < min)
       min = fin2;
     if(fin3 < min)
       min = fin3;
     return str.substr(0, min);
   }
  }
 
  fnAvisoNoSoportado(){
   console.log("NO SOPORTADO !");
   alert(this.navegador.name + "\n" + this.navegador.code + "\n" + this.navegador.ver);
   
   setTimeout(() => {
       let dialogRef = this.dialog.open(PopupComponent, {
         width: '520px',
         data: { 
           timer: 15,
           titulo: "Atención",
           texto1: `Este navegador no cumple con los estandares HTML5/CSS3.`,
           texto2: `El sitio opera bajo los estándares HTML5/CSS3 por lo que éste navegador
                   no es soportado.`,
           texto3: `Utilice el navegador "Chrome" para visualizar el sitio; también están soportados 
                   los navegadores "Firefox (65+)" y "Edge(45+)" y "Safari (12+)" `  
               }
       });
     }, 1000);
  }
 
  fnAvisoRecomendacion(){
   console.log("SE RECOMIENDA EL USO DE CHROME")
   //alert(this.navegador.name + "\n" + this.navegador.code + "\n" + this.navegador.ver);
   setTimeout(() => {
     let dialogRef = this.dialog.open(PopupComponent, {
       width: '520px',
       data: { 
         timer: 10,
         titulo: "Atención",
         texto1: `Algunas de las funcionalidades del sitio no han sido revisadas en éste navegador.`,
         texto2: `Para asegurar la experiencia 
                  del usuario, recomendamos utilizar el navegador "Chrome".`,
         texto3: ` 
                 `  
             }
     });
   }, 1000);  
  }
 
  isAlive():Observable<string> {
   return this.http.post<string>(this.urlAlive, '', httpOptions).pipe(
     tap((data: any) => this.log(`${data}`)),
     catchError(this.handleError<string>('isAlive'))
   );
  }
 
  fnGetHost(){
   return this.myHost;
  }
 
  onlyUnique(value, index, self) { 
   return self.indexOf(value) === index;
  }
 
  trim(str, chars) {
   if(!str)
     str='';
   return this.ltrim(this.rtrim(str.toString().replace('   ',' ').replace('  ',' '), chars), chars);
  }
  
  ltrim(str, chars) {
   if(str==null)
     str="";
   chars = chars || "\s";
   return str.toString().replace(new RegExp("^[" + chars + "]+", "g"), "");
  }
  
  rtrim(str, chars) {
    if(str==null)
     str="";
   chars = chars || "\s";
   return str.toString().replace(new RegExp("[" + chars + "]+$", "g"), "");
  }
 
  fnWait(ms){
   var start = new Date().getTime();
   var end = start;
   while(end < start + ms) {
     end = new Date().getTime();
   }
  }

  fnLlenaEspacios(texto:string, caracteres:number, posicion:string){
    var aux="";
    if(posicion=="ANTES"){
      for(var e = texto.length; e < caracteres; e++){
        aux+=" ";
      }
      aux+=texto;
    }
    if(posicion=="DESPUES"){
      aux=texto;
      for(var e = texto.length; e < caracteres; e++){
        aux+=" ";
      }
    }
    //console.log(aux + ": " +  aux.length + " > " + caracteres)
    if(aux.length > caracteres)
      aux = aux.substring(0, caracteres-3) + "...";
    return aux;
  } 
  
  findItemInObject(obj, id_cve_unica, campoIdentificador){
    for(var nitems = 0; nitems < obj.length; nitems++){
      if(obj[nitems][campoIdentificador]  == id_cve_unica)
        return obj[nitems];
    }
  }
 
  findItemInObject2Attributes(obj, id_cve1, campoIdentificador1, id_cve2, campoIdentificador2){
   for(var nitems = 0; nitems < obj.length; nitems++){
     if(obj[nitems][campoIdentificador1] == id_cve1 && obj[nitems][campoIdentificador2] == id_cve2)
       return obj[nitems];
   }
  }
 
  find(arr, id_valorBuscado, campoBusqueda, campoRetorno){
   //console.log(arr)
   //console.log(id_valorBuscado)
   try{
       if(arr[campoBusqueda]){
         let obj = arr.find(o => o[campoBusqueda] === id_valorBuscado);
         //console.log(obj[campoRetorno]);
         return obj[campoRetorno];
       }
       else
         return "-!!-";
     }
     catch(err){
       console.log("ERROR EN find():");
       console.log(arr);
       console.log(id_valorBuscado)
       return "-!-";
     }
  }
 
  arrayRemove(arr, value) {
   return arr.filter(function(ele){
       return ele != value;
   });
  }
 
  fnReturnFormVals(id, form: FormGroup, otros){
   var aux = [];
   var auxVal = "?";
   var auxKeys = Object.keys(form.controls);
   if(id)
     auxVal = id;
   aux.push("ID:" + auxVal);
   for(var i = 0; i<  auxKeys.length; i++){
     auxVal = "?";
     if(form.controls[auxKeys[i]].value)
       auxVal = form.controls[auxKeys[i]].value;
     console.log(auxVal)
     aux.push(auxKeys[i] + ':' + auxVal.toString().replace(/'/g, '"') + '');
   }
   if(otros)
     if(otros!='')
       aux.push(otros);
   return aux.join("|");
  }
 
  validKey(t,e){
         //console.log(t);
         //console.log(e.charCode);
          var esBorradoFlechaTab = false;
          var esNumero = false;
          var esLetraMinuscula = false;
          var esLetraMayuscula = false;
          var esAcentoMinuscula = false;
          var esAcentoMayuscula = false;
          var esEspacio = false;
          var esEnter = false;
          if(e.key=="Dead"){
            return false;
          }
          //if(e.charCode==46 || e.charCode==8 || e.charCode==37 || e.charCode==39 || e.charCode==9) //--> NO USAR SOLO CHARCODE!! ya que significan otra cosa
          if(e.key=="Delete" || e.key=="Backspace" || e.key=="ArrowLeft" || e.key=="ArrowRight" || e.key=="Tab")
            esBorradoFlechaTab = true;
          if(e.charCode >= 48 && e.charCode <= 57)
            esNumero = true;
          if((e.charCode  >= 65 && e.charCode  <= 90) || e.key == 'Ñ' || e.charCode == 209)
            esLetraMayuscula = true;
          if((e.charCode  >= 97 && e.charCode  <= 122 && e.key != "+") || e.key == 'ñ' || e.charCode == 241)
            esLetraMinuscula = true;  
          if(e.key == 'Á' || e.charCode == 193 || e.key == 'É' || e.charCode == 201 || e.key == 'Í' || e.charCode == 205 || e.key == 'Ó' || e.charCode == 211 || e.key == 'Ú' || e.charCode == 218)
            esAcentoMayuscula = true;
          if(e.key == 'á' || e.charCode == 225 || e.key == 'é' || e.charCode == 233 || e.key == 'í' || e.charCode == 237 || e.key == 'ó' || e.charCode == 243 || e.key == 'ú' || e.charCode == 250)
            esAcentoMinuscula = true; 
          if(e.key == ' ' || e.charCode==32)
            esEspacio=true;
          if(e.key == 'Enter' || e.charCode==13)
            esEnter=true;
      
          if(t=='NUMERO' || t=='TEL'){
            if(!esBorradoFlechaTab && !esNumero && !esEnter)
                return false;           
          }
          if(t=='UUID'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="A" || e.charCode==65 || e.key=="B" || e.charCode==66  || e.key=="C" || e.charCode==67 || e.key=="D" || e.charCode==68 || e.key=="E" || e.charCode==69 || e.key=="F" || e.charCode==70 || e.key=="-" || e.charCode==45)
               return true;
             else
               return false;
           }
         }
          if(t=='MONTO'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45)
               return true;
             else
               return false;
           }
         }
          if(t=='DECIMAL'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="_" || e.charCode==95)
               return true;
             else
               return false;
           }
         }
         if(t=='PTO'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="_" || e.charCode==95)
               return true;
             else
               return false;            
           }
         }
         if(t=='IP'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95)
               return true;
             else
               return false;        
           }
         }
         if(t=='PISO'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95 || e.key=="+" || e.charCode==43 ||
             e.key==":" || e.charCode==58 || e.key=="*" || e.charCode==42 || e.key=="P" || e.charCode==80 || e.key=="H" || e.charCode==72 )
               return true;
             else
               return false;        
           }
         }          
         if(t=='VIG'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="/" || e.charCode==47)
               return true;
             else
               return false;        
           }
         }  
         if(t=='COORD'){
           if(!esBorradoFlechaTab && !esNumero && !esEnter){
             if(e.key=="." || e.charCode==46 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95)
               return true;
             else
               return false;        
           }
         }                
         if(t=='NOMBRE'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esAcentoMayuscula && !esAcentoMinuscula && !esEspacio && !esEnter){
               return false;
           }
         }
         if(t=='BUSQUEDA'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
            if( e.key== "%"    || e.key=="_"       
             || e.charCode==37 || e.charCode==95  )
               return true;
             else
               return false;
           }
         }
         if(t=='RFC'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
            if( e.key== "&"         
             || e.charCode==38  )
               return true;
             else
               return false;
           }
         }
         if(t=='TEXTO' || t == 'PWD' || t == 'ID'){
            if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esAcentoMayuscula && !esAcentoMinuscula && !esEspacio && !esEnter){
             if( e.key== "$"    || e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key== "#"    || e.key=="@"     || e.key=="."     || e.key==","     || e.key==":"     || e.key==";"     || e.key=="*"     || e.key=="-"     || e.key=="%"     || e.key=="!"     || e.key=="?"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
              || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==58 || e.charCode==59 || e.charCode==42 || e.charCode==45 || e.charCode==37 || e.charCode==33 || e.charCode==63 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
                return true;
              else
                return false;
            }
         }
         if(t=='MAIL'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
             if(e.key=="." || e.charCode==46 ||  e.key=="+" || e.charCode==43 || e.key=="-" || e.charCode==45 || e.key=="_" || e.charCode==95 ||  e.key=="@" || e.charCode==64)
               return true;
             else
               return false;
           }    
         }         
         if(t=='URL'){
            if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esEspacio && !esEnter){
              if( e.key== "$"    ||e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key=="#"     || e.key=="@"     || e.key=="."     || e.key==","     || e.key==":"     || e.key==";"     || e.key=="*"     || e.key=="-"     || e.key=="%"     || e.key=="!"     || e.key=="?"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
              || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==58 || e.charCode==59 || e.charCode==42 || e.charCode==45 || e.charCode==37 || e.charCode==33 || e.charCode==63 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
                return true;
              else
                return false;             
            }
         }
         if(t=='FILE'){
           if(!esBorradoFlechaTab && !esNumero && !esLetraMayuscula && !esLetraMinuscula && !esAcentoMayuscula && !esAcentoMinuscula && !esEspacio && !esEnter){
             if( e.key=="$"    || e.key== "&"    || e.key== "="    || e.key== "+"    || e.key== "/"    || e.key== "#"    || e.key=="@"     || e.key=="."     || e.key==","     || e.key==";"     || e.key=="-"     || e.key=="!"     || e.key=="("     || e.key==")"     || e.key=="["     || e.key=="]"     || e.key=="_"     
             || e.charCode==36 || e.charCode==38 || e.charCode==61 || e.charCode==43 || e.charCode==47 || e.charCode==35 || e.charCode==64 || e.charCode==46 || e.charCode==44 || e.charCode==59 || e.charCode==45 || e.charCode==33 || e.charCode==40 || e.charCode==41 || e.charCode==91 || e.charCode==93 || e.charCode==95 )
               return true;
             else
               return false;            
           }
         }         
         return true;
  }
 
  fnGetIVA(){
    return this.IVA;
  }
  
  fnFormatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    if(amount == null)
      amount = 0;
    try {
      //console.log(parseFloat(amount).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
      return parseFloat(amount).toFixed(decimalCount).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    } catch (e) {
      console.log("ERROR:")
      console.log(e)
    }
  };
  
  fnLeeMonto(monto){
    console.log(monto);
    if(monto == 0 || monto == undefined)
      return "CERO PESOS (00/100) M.N.";
    //--> Funciondiseñada hasta el número 99,999.99 (5 digitos enteros) < 100K
    var auxInt = Math.trunc(monto);
    var auxDec = Math.round((monto - auxInt)*100);
    var auxDig = "";
    var auxDigSig = "";
    var auxDigSig2 = "";
    var auxTxt = "";
    var salta = false;
    for(var pos = auxInt.toString().length - 1; pos >= 0; pos--){
      if(salta){
        salta = false;
        continue;
      }
      auxDig = auxInt.toString().substr(auxInt.toString().length - pos -1, 1)
      if(pos > 0)
        auxDigSig = auxInt.toString().substr(auxInt.toString().length - pos, 1)
      if(pos > 1)
        auxDigSig2 = auxInt.toString().substr(auxInt.toString().length - pos + 1, 1)
      if(pos == 0){
        if(auxDig=="1")
          auxTxt += "UNO";
        if(auxDig=="2")
          auxTxt += "DOS";
        if(auxDig=="3")
          auxTxt += "TRES";
        if(auxDig=="4")
          auxTxt += "CUATRO";
        if(auxDig=="5")
          auxTxt += "CINCO";
        if(auxDig=="6")
          auxTxt += "SEIS";
        if(auxDig=="7")
          auxTxt += "SIETE";
        if(auxDig=="8")
          auxTxt += "OCHO";
        if(auxDig=="9")
          auxTxt += "NUEVE";
      }    
      if(pos == 1){
        if(auxDig=="3")
          auxTxt += "TREINTA";
        if(auxDig=="4")
          auxTxt += "CUARENTA";
        if(auxDig=="5")
          auxTxt += "CINCUENTA";
        if(auxDig=="6")
          auxTxt += "SESENTA";
        if(auxDig=="7")
          auxTxt += "SETENTA";
        if(auxDig=="8")
          auxTxt += "OCHENTA";
        if(auxDig=="9")
          auxTxt += "NOVENTA";
        if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig != "0")
          auxTxt += " Y ";
        if(auxDig == "1" && auxDigSig== "0"){
          auxTxt += "DIEZ";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "1"){
          auxTxt += "ONCE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "2"){
          auxTxt += "DOCE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "3"){
          auxTxt += "TRECE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "4"){
          auxTxt += "CATORCE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "5"){
          auxTxt += "QUINCE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "6"){
          auxTxt += "DIECISEIS";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "7"){
          auxTxt += "DIECISIETE";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "8"){
          auxTxt += "DIECIOCHO";
          salta = true;
        }
        if(auxDig == "1" && auxDigSig== "9"){
          auxTxt += "DIECINUEVE";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "0"){
          auxTxt += "VEINTE";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "1"){
          auxTxt += "VEINTIUNO";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "2"){
          auxTxt += "VEINTIDOS";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "3"){
          auxTxt += "VEINTITRES";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "4"){
          auxTxt += "VEINTICUATRO";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "5"){
          auxTxt += "VEINTICINCO";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "6"){
          auxTxt += "VEINTISEIS";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "7"){
          auxTxt += "VEINTISIETE";
           salta = true;
        }
        if(auxDig == "2" && auxDigSig== "8"){
          auxTxt += "VEINTIOCHO";
          salta = true;
        }
        if(auxDig == "2" && auxDigSig== "9"){
          auxTxt += "VEINTINUEVE";
          salta = true;
        }
      }    
      if(pos == 2){
        if(auxDig=="2")
          auxTxt += "DOSCIENTOS";
        if(auxDig=="3")
          auxTxt += "TRESCIENTOS";
        if(auxDig=="4")
          auxTxt += "CUATROCIENTOS";
        if(auxDig=="5")
          auxTxt += "QUINIENTOS";
        if(auxDig=="6")
          auxTxt += "SEISCIENTOS";
        if(auxDig=="7")
          auxTxt += "SETECIENTOS";
        if(auxDig=="8")
          auxTxt += "OCHOCIENTOS";
        if(auxDig=="9")
          auxTxt += "NOVECIENTOS";
        if(auxDig == "1" && auxDigSig != "0")
          auxTxt += "CIENTO";
        if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 != "0"){
          auxTxt += "CIENTO";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 == "0"){
          auxTxt += "CIEN";
          salta=true;
        }
      }
      if(pos == 3){
        if(auxDig=="0")
          auxTxt += "MIL";
        if(auxDig=="1")
          auxTxt += "MIL";
        if(auxDig=="2")
          auxTxt += "DOS MIL";
        if(auxDig=="3")
          auxTxt += "TRES MIL";
        if(auxDig=="4")
          auxTxt += "CUATRO MIL";
        if(auxDig=="5")
          auxTxt += "CINCO MIL";
        if(auxDig=="6")
          auxTxt += "SEIS MIL";
        if(auxDig=="7")
          auxTxt += "SIETE MIL";
        if(auxDig=="8")
          auxTxt += "OCHO MIL";
        if(auxDig=="9")
          auxTxt += "NUEVE MIL";
      }
      if(pos == 4){
        if(auxDig=="3")
          auxTxt += "TREINTA";
        if(auxDig=="4")
          auxTxt += "CUARENTA";
        if(auxDig=="5")
          auxTxt += "CINCUENTA";
        if(auxDig=="6")
          auxTxt += "SESENTA";
        if(auxDig=="7")
          auxTxt += "SETENTA";
        if(auxDig=="8")
          auxTxt += "OCHENTA";
        if(auxDig=="9")
          auxTxt += "NOVENTA";
        if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig == "0"){   //--> 11011.13, 31027.13
          auxTxt += " MIL";
          salta=true;
        }
        if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig != "0" && auxDigSig != "1")
          auxTxt += " Y ";
        if((auxDig == "3" || auxDig == "4" || auxDig == "5" || auxDig == "6" || auxDig == "7" || auxDig == "8" || auxDig == "9") && auxDigSig == "1"){   //--> 11011.13, 31027.13
          auxTxt += " Y UN MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "0"){
          auxTxt += "DIEZ MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "1"){
          auxTxt += "ONCE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "2"){
          auxTxt += "DOCE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "3"){
          auxTxt += "TRECE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "4"){
          auxTxt += "CATORCE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "5"){
          auxTxt += "QUINCE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "6"){
          auxTxt += "DIECISEIS MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "7"){
          auxTxt += "DIECISIETE MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "8"){
          auxTxt += "DIECIOCHO MIL";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig== "9"){
          auxTxt += "DIECINUEVE MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "0"){
          auxTxt += "VEINTE MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "1"){
          auxTxt += "VEINTIUN MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "2"){
          auxTxt += "VEINTIDOS MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "3"){
          auxTxt += "VEINTITRES MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "4"){
          auxTxt += "VEINTICUATRO MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "5"){
          auxTxt += "VEINTICINCO MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "6"){
          auxTxt += "VEINTISEIS MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "7"){
          auxTxt += "VEINTISIETE MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "8"){
          auxTxt += "VEINTIOCHO MIL";
          salta=true;
        }
        if(auxDig == "2" && auxDigSig== "9"){
          auxTxt += "VEINTINUEVE MIL";
          salta=true;
        }
      }    
      if(pos == 5){
        if(auxDig=="2")
          auxTxt += "DOSCIENTOS";
        if(auxDig=="3")
          auxTxt += "TRESCIENTOS";
        if(auxDig=="4")
          auxTxt += "CUATROCIENTOS";
        if(auxDig=="5")
          auxTxt += "QUINIENTOS";
        if(auxDig=="6")
          auxTxt += "SEISCIENTOS";
        if(auxDig=="7")
          auxTxt += "SETECIENTOS";
        if(auxDig=="8")
          auxTxt += "OCHOCIENTOS";
        if(auxDig=="9")
          auxTxt += "NOVECIENTOS";
        if(auxDig == "1" && auxDigSig != "0")
          auxTxt += "CIENTO";
        if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 != "0"){
          auxTxt += "CIENTO";
          salta=true;
        }
        if(auxDig == "1" && auxDigSig == "0" && auxDigSig2 == "0"){
          auxTxt += "CIEN";
          salta=true;
        }
      }
      if(pos == 6){
        if(auxDig=="1")
          auxTxt += "UN MILLON";
        if(auxDig=="2")
          auxTxt += "DOS MILLONES";
        if(auxDig=="3")
          auxTxt += "TRES MILLONES";
        if(auxDig=="4")
          auxTxt += "CUATRO MILLONES";
        if(auxDig=="5")
          auxTxt += "CINCO MILLONES";
        if(auxDig=="6")
          auxTxt += "SEIS MILLONES";
        if(auxDig=="7")
          auxTxt += "SIETE MILLONES";
        if(auxDig=="8")
          auxTxt += "OCHO MILLONES";
        if(auxDig=="9")
          auxTxt += "NUEVE MILLONES";
        if(auxDigSig == "0" ){
            salta=true;
          }
      }
      auxTxt += " ";
    }
    return "" +  auxTxt.replace(/  /g," ") + "PESOS (" + ("0" + auxDec.toString()).substr(-2) + "/100) M.N.";
  }

  fnGetHoy(){
    var auxHoy = new Date();
    var year = auxHoy.getFullYear();
    var month = auxHoy.getMonth() + 1;
    var day = auxHoy.getDate();
    var m = "";
    var d = "";
    if(month < 10)
      m = "0" + month;
    else
      m = "" + month;
    if(day < 10)
      d = "0" + day;
    else
      d = "" + day;
    //console.log("HOY: " + year + "-" + m + "-" + d);
    return year + "-" + m + "-" + d;
  } 
  
  fnGetAhora(){
    var auxAhora = new Date();
    var hora = auxAhora.getHours();
    var min = auxAhora.getMinutes();
    var seg = auxAhora.getSeconds();
    var h = "";
    var m = "";
    var s = "";
    if(hora < 10)
      h = "0" + hora;
    else
      h = hora.toString();
    if(min < 10)
      m = "0" + min;
    else
      m = min.toString();
    if(seg < 10)
      s = "0" + seg.toString();
    else  
      s = seg.toString();
    //console.log(h + ":" + m + ":" + s)
    return h + ":" + m + ":" + s;
   }
  
   fnGetAhoraMS(){
    var auxAhora = new Date();
    var hora = auxAhora.getHours();
    var min = auxAhora.getMinutes();
    var seg = auxAhora.getSeconds();
    var mseg = auxAhora.getMilliseconds();
    var h = "";
    var m = "";
    var s = "";
    if(hora < 10)
      h = "0" + hora;
    else
      h = hora.toString();
    if(min < 10)
      m = "0" + min;
    else
      m = min.toString();
    if(seg < 10)
      s = "0" + seg.toString();
    else  
      s = seg.toString();
    //console.log(h + ":" + m + ":" + s)
    return h + ":" + m + ":" + s + "." + mseg;
   }
  
   fnGetDate(strFecha){
     //console.log("Fecha en formato yyyy-mm-dd: " + strFecha);
     var yy = parseInt(strFecha.substr(0,4));
     var mm = parseInt(strFecha.substr(5,2)) - 1;
     var dd = parseInt(strFecha.substr(-2));
     if(mm < 0){
        yy = yy - 1;
        mm = 11
     }   
     var auxDate = new Date(yy, mm, dd);
     return auxDate;
   }
  
   fnGetDateFormat(strFecha, strFormat){
    //console.log("Fecha en formato yyyy-mm-dd: " + strFecha);
    if(strFecha == undefined || strFecha == null)
      strFecha = "1900-01-01";
    var monthNames = [
      "Enero", "Febrero", "Marzo",
      "Abril", "Mayo", "Junio", "Julio",
      "Agosto", "Septiembre", "Octubre",
      "Noviembre", "Diciembre"
    ]
    var monthAbr = [
      "Ene", "Feb", "Mar",
      "Abr", "May", "Jun", "Jul",
      "Ago", "Sep", "Oct",
      "Nov", "Dic"
    ]
    var yy = parseInt(strFecha.substr(0,4));  
    var mm = parseInt(strFecha.substr(5,2)) - 1;  
    var dd = parseInt(strFecha.substr(8,2)); 
    var auxDate = new Date(yy, mm, dd);
    //console.log("auxDate = " + auxDate);
    //console.log(strFormat);
    var formatDate = ""
    formatDate = "" + parseInt(strFecha.substr(-2)) + "/" + parseInt(strFecha.substr(5,2)) + "/" + yy;
    if(strFormat == "MMDY")
      formatDate = monthNames[mm] + " " + dd + ", " + yy;
    if(strFormat == "DMY")
      formatDate = dd + " / " + monthAbr[mm] + " / " + yy;    
    if(strFormat == "DMMY")
      formatDate = dd + " de " + monthNames[mm] + " de " + yy;    
    if(strFormat == "MMY")
      formatDate = monthNames[mm] + " de " + yy;    
    if(strFormat == "DMM")
      formatDate = dd + " de " + monthNames[mm];    
    if(strFormat == "MM")
      formatDate = monthNames[mm];    
    if(strFormat == "D")
      formatDate = dd < 10 ? "0" + dd : dd + "";    
    if(strFormat == "TRIY")
      formatDate = monthNames[mm] + " a " + monthNames[mm + 3] + " de " + yy;    
    if(strFormat == "DMMMY")
      formatDate = dd + " de " + monthAbr[mm] + " de " + yy;
    if(strFormat == "Y-M-D")
      formatDate =  yy + "-" + strFecha.substr(5,2) + "-" + strFecha.substr(8,2);
    if(strFormat == "D/M/Y"){
      formatDate = strFecha.substr(8,2) + "/" + strFecha.substr(5,2) + "/" + yy;
    }
    //console.log(strFormat);
    return formatDate.toString();
  }
  
   fnDateDiff(date1, date2, interval) {
    var second=1000, minute=second*60, hour=minute*60, day=hour*24, week=day*7;
    date1 = new Date(date1);
    date2 = new Date(date2);
    var timediff = date2 - date1;
    if (isNaN(timediff)) return NaN;
    switch (interval) {
        case "YEARS": return date2.getFullYear() - date1.getFullYear();
        case "MONTHS": return (
            ( date2.getFullYear() * 12 + date2.getMonth() )
            -
            ( date1.getFullYear() * 12 + date1.getMonth() )
        );
        case "WEEKS"  : return Math.floor(timediff / week);
        case "DAYS"   : return Math.floor(timediff / day); 
        case "HOURS"  : return Math.floor(timediff / hour); 
        case "MINUTES": return Math.floor(timediff / minute);
        case "SECONDS": return Math.floor(timediff / second);
        default: return undefined;
    }
  }
  

  fnReplaceSpecialStrings(cadena, arrData){
    var auxCadena = cadena;
    if(arrData[0].COL){    //--> SOLO PARA REPORTES!
      //console.log(arrData[0].COL)
      //console.log(arrData[0].COL[0])
      auxCadena = auxCadena.replace(/ƒCOL_TIT_0/g, arrData[0].COLTIT[0]);
      auxCadena = auxCadena.replace(/ƒCOL_0/g, arrData[0].COL[0].replace(/ƒ/g,"\n"));
      auxCadena = auxCadena.replace(/ƒCOL_TIT_1/g, arrData[0].COLTIT[1]);
      auxCadena = auxCadena.replace(/ƒCOL_1/g, arrData[0].COL[1].replace(/ƒ/g,"\n"));
      auxCadena = auxCadena.replace(/ƒCOL_TIT_2/g, arrData[0].COLTIT[2]);
      auxCadena = auxCadena.replace(/ƒCOL_2/g, arrData[0].COL[2].replace(/ƒ/g,"\n"));
      auxCadena = auxCadena.replace(/ƒCOL_TIT_3/g, arrData[0].COLTIT[3]);
      auxCadena = auxCadena.replace(/ƒCOL_3/g, arrData[0].COL[3].replace(/ƒ/g,"\n"));
      if(arrData[0].COLTIT[4]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_4/g, arrData[0].COLTIT[4]);
        auxCadena = auxCadena.replace(/ƒCOL_4/g, arrData[0].COL[4].replace(/ƒ/g,"\n"));
      }
      if(arrData[0].COLTIT[5]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_5/g, arrData[0].COLTIT[5]);
        auxCadena = auxCadena.replace(/ƒCOL_5/g, arrData[0].COL[5].replace(/ƒ/g,"\n"));
      }
      if(arrData[0].COLTIT[6]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_6/g, arrData[0].COLTIT[6]);
        auxCadena = auxCadena.replace(/ƒCOL_6/g, arrData[0].COL[6].replace(/ƒ/g,"\n"));
      }
      else{
        auxCadena = auxCadena.replace(/ƒCOL_TIT_6/g, "");      
        auxCadena = auxCadena.replace(/ƒCOL_6/g, "");      
      }
      if(arrData[0].COLTIT[7]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_7/g, arrData[0].COLTIT[7]);
        auxCadena = auxCadena.replace(/ƒCOL_7/g, arrData[0].COL[7].replace(/ƒ/g,"\n"));
      }
      else{
        auxCadena = auxCadena.replace(/ƒCOL_TIT_7/g, "");      
        auxCadena = auxCadena.replace(/ƒCOL_7/g, "");      
      }
      if(arrData[0].COLTIT[8]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_8/g, arrData[0].COLTIT[8]);
        auxCadena = auxCadena.replace(/ƒCOL_8/g, arrData[0].COL[8].replace(/ƒ/g,"\n"));
      }
      else{
        auxCadena = auxCadena.replace(/ƒCOL_TIT_8/g, "");      
        auxCadena = auxCadena.replace(/ƒCOL_8/g, "");      
      }
      if(arrData[0].COLTIT[9]){
        auxCadena = auxCadena.replace(/ƒCOL_TIT_9/g, arrData[0].COLTIT[9]);
        auxCadena = auxCadena.replace(/ƒCOL_9/g, arrData[0].COL[9].replace(/ƒ/g,"\n"));
      }
      else{
        auxCadena = auxCadena.replace(/ƒCOL_TIT_9/g, "");      
        auxCadena = auxCadena.replace(/ƒCOL_9/g, "");      
      }
    }
    auxCadena = auxCadena.replace(/ƒFILTRO1/g, arrData[0].FILTRO1).replace(/ƒFILTRO2/g, arrData[0].FILTRO2).replace(/ƒFILTRO3/g, arrData[0].FILTRO3);
    auxCadena = auxCadena.replace(/ƒn/g, "\n").replace(/ƒVIÑETA/g, "\u00BB").replace(/ƒt/g, "\t").replace(/ƒNBSP/g, "\u00A0");;
    auxCadena = auxCadena.replace(/ƒRFC/g, arrData[0].RFC).replace(/ƒCP/g, arrData[0].CP).replace(/ƒTEL/g, arrData[0].TEL).replace(/ƒDIR1/g, arrData[0].DIR1).replace(/ƒDIR2/g, arrData[0].DIR2);
    auxCadena = auxCadena.replace(/ƒFECHAMMDY/g, this.fnGetDateFormat(this.fnGetHoy(),"MMDY"));
    auxCadena = auxCadena.replace(/ƒFECHADMMY/g, this.fnGetDateFormat(this.fnGetHoy(),"DMMY"));
    auxCadena = auxCadena.replace(/ƒFECHADMY/g, this.fnGetDateFormat(this.fnGetHoy(),"DMY"));
    auxCadena = auxCadena.replace(/ƒHORAHMS/g, this.fnGetAhora()).replace(/ƒFECHACER/g, arrData[0].FECHACER);
    auxCadena = auxCadena.replace(/ƒTITULO/g, arrData[0].TITULO).replace(/ƒFOLIO/g, arrData[0].FOLIO).replace(/ƒFECHAEMI/g, arrData[0].FECHAEMI).replace(/ƒDESCUENTO/g, arrData[0].DESCUENTO);
    auxCadena = auxCadena.replace(/ƒPROD/g, arrData[0].PROD).replace(/ƒQTY/g, arrData[0].QTY).replace(/ƒTOTAL/g, arrData[0].TOTAL).replace(/ƒOTRO/g, arrData[0].OTRO)
    auxCadena = auxCadena.replace(/ƒDESTINATARIO/g, arrData[0].DESTINATARIO).replace(/ƒDESTINA_PUESTO/g, arrData[0].DESTINA_PUESTO).replace(/ƒPERIODICIDAD/g, arrData[0].PERIODICIDAD);
    auxCadena = auxCadena.replace(/ƒPERIODO/g, arrData[0].PERIODO).replace(/ƒNUMACTS/g, arrData[0].NUMACTS).replace(/ƒNUMASIS/g, arrData[0].NUMASIS);
    auxCadena = auxCadena.replace(/ƒNUMASI_LETRA/g, arrData[0].NUMASI_LETRA).replace(/ƒMETAACTS/g, arrData[0].METAACTS).replace(/ƒMETAASIS/g, arrData[0].METAASIS);
    auxCadena = auxCadena.replace(/ƒRESACTS/g, arrData[0].RESACTS).replace(/ƒRESASIS/g, arrData[0].RESASIS).replace(/ƒJUSTIFICA/g, arrData[0].JUSTIFICA).replace(/ƒJEFE_TAQ/g, arrData[0].JEFE_TAQ).replace(/ƒCONTABILIDAD/g, arrData[0].CONTABILIDAD);
    auxCadena = auxCadena.replace(/ƒFORMA/g, arrData[0].FORMA).replace(/ƒAREA/g, arrData[0].AREA);
    auxCadena = auxCadena.replace(/ƒMONTO29/g, arrData[0].MONTO29).replace(/ƒMONTO28/g, arrData[0].MONTO28).replace(/ƒMONTO27/g, arrData[0].MONTO27).replace(/ƒMONTO26/g, arrData[0].MONTO26).replace(/ƒMONTO25/g, arrData[0].MONTO25);
    auxCadena = auxCadena.replace(/ƒMONTO24/g, arrData[0].MONTO24).replace(/ƒMONTO23/g, arrData[0].MONTO23).replace(/ƒMONTO22/g, arrData[0].MONTO22).replace(/ƒMONTO21/g, arrData[0].MONTO21).replace(/ƒMONTO20/g, arrData[0].MONTO20);
    auxCadena = auxCadena.replace(/ƒMONTO19/g, arrData[0].MONTO19).replace(/ƒMONTO18/g, arrData[0].MONTO18).replace(/ƒMONTO17/g, arrData[0].MONTO17).replace(/ƒMONTO16/g, arrData[0].MONTO16).replace(/ƒMONTO15/g, arrData[0].MONTO15);
    auxCadena = auxCadena.replace(/ƒMONTO14/g, arrData[0].MONTO14).replace(/ƒMONTO13/g, arrData[0].MONTO13).replace(/ƒMONTO12/g, arrData[0].MONTO12).replace(/ƒMONTO11/g, arrData[0].MONTO11).replace(/ƒMONTO10/g, arrData[0].MONTO10);
    auxCadena = auxCadena.replace(/ƒMONTO9/g, arrData[0].MONTO9).replace(/ƒMONTO8/g, arrData[0].MONTO8).replace(/ƒMONTO7/g, arrData[0].MONTO7).replace(/ƒMONTO6/g, arrData[0].MONTO6).replace(/ƒMONTO5/g, arrData[0].MONTO5);
    auxCadena = auxCadena.replace(/ƒMONTO4/g, arrData[0].MONTO4).replace(/ƒMONTO3/g, arrData[0].MONTO3).replace(/ƒMONTO2/g, arrData[0].MONTO2).replace(/ƒMONTO1/g, arrData[0].MONTO1).replace(/ƒMONTO/g, arrData[0].MONTO);
    auxCadena = auxCadena.replace(/ƒLINEA29/g, arrData[0].LINEA29).replace(/ƒLINEA28/g, arrData[0].LINEA28).replace(/ƒLINEA27/g, arrData[0].LINEA27).replace(/ƒLINEA26/g, arrData[0].LINEA26).replace(/ƒLINEA25/g, arrData[0].LINEA25);
    auxCadena = auxCadena.replace(/ƒLINEA24/g, arrData[0].LINEA24).replace(/ƒLINEA23/g, arrData[0].LINEA23).replace(/ƒLINEA22/g, arrData[0].LINEA22).replace(/ƒLINEA21/g, arrData[0].LINEA21).replace(/ƒLINEA20/g, arrData[0].LINEA20);
    auxCadena = auxCadena.replace(/ƒLINEA19/g, arrData[0].LINEA19).replace(/ƒLINEA18/g, arrData[0].LINEA18).replace(/ƒLINEA17/g, arrData[0].LINEA17).replace(/ƒLINEA16/g, arrData[0].LINEA16).replace(/ƒLINEA15/g, arrData[0].LINEA15);
    auxCadena = auxCadena.replace(/ƒLINEA14/g, arrData[0].LINEA14).replace(/ƒLINEA13/g, arrData[0].LINEA13).replace(/ƒLINEA12/g, arrData[0].LINEA12).replace(/ƒLINEA11/g, arrData[0].LINEA11).replace(/ƒLINEA10/g, arrData[0].LINEA10);
    auxCadena = auxCadena.replace(/ƒCATEG/g, arrData[0].CATEG).replace(/ƒLINEA1/g, arrData[0].LINEA1).replace(/ƒLINEA2/g, arrData[0].LINEA2).replace(/ƒLINEA3/g, arrData[0].LINEA3).replace(/ƒLINEA4/g, arrData[0].LINEA4).replace(/ƒLINEA5/g, arrData[0].LINEA5).replace(/ƒLINEA6/g, arrData[0].LINEA6).replace(/ƒLINEA7/g, arrData[0].LINEA7);
    auxCadena = auxCadena.replace(/ƒLINEA8/g, arrData[0].LINEA8).replace(/ƒLINEA9/g, arrData[0].LINEA9).replace(/ƒLINEAA/g, arrData[0].LINEAA).replace(/ƒLINEAB/g, arrData[0].LINEAB).replace(/ƒLINEAC/g, arrData[0].LINEAC).replace(/ƒLINEAD/g, arrData[0].LINEAD).replace(/ƒLINEAE/g, arrData[0].LINEAE);
    auxCadena = auxCadena.replace(/ƒSUBEFECTIVO/g, arrData[0].SUBEFECTIVO).replace(/ƒSUBOTROS/g, arrData[0].SUBOTROS)  
    return auxCadena
  }

  getCurrentRol(){
    return parseInt(sessionStorage.getItem('csiBILLusrR'));
  }
  
  getCurrentUsr(){
    return sessionStorage.getItem('csiBILLusr');
  }
  
  getCurrentUsuario(){
    return sessionStorage.getItem('csiBILLusrN');
  }
  
  sysVer():Observable<string> {
    var para = [];
    para.push();
    return this.http.post<string>(this.urlSysVer, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('sysVer'))
    );
  }
  
  sendMail(f,m,u,n,h,pto,us,pw,ssl,tsl){
    var url = "";
    var para = [];    
    var obj;  
    if (f=="RECUP"){
      obj =  {
        'm': m,
        'u': u,
        'n': n,
        'mailh': h,
        'mailpto': pto,
        'mailus': us,
        'mailssl': ssl,
        'mailtsl': tsl,
        'mailpw': pw,
        'sysn': this.sN,
        'syswe': this.sWe
      }    
      url = this.urlMailRec;
    }
    if (f=="PBA"){
      obj =  {
        'm': m,
        'mailh': h,
        'mailpto': pto,
        'mailus': us,
        'mailssl': ssl,
        'mailtsl': tsl,
        'mailpw': pw,
        'sysn': this.sN,
        'syswe': this.sWe
      }   
      url = this.urlMailPba;
    }
    if (f=="LOG"){
      obj =  {
        'm': m,
        'u': u,
        'n': n,
        'mailh': h,
        'mailpto': pto,
        'mailus': us,
        'mailssl': ssl,
        'mailtsl': tsl,
        'mailpw': pw,
        'sysn': this.sN,
        'syswe': this.sWe
      }   
      url = this.urlMailLog;
    }
    para.push(obj);
    return this.http.post<string>(url, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('sendMail'))
    );  
 }

 sendMailLog(sub, msg, m, n){
  var url = "";
  var para = [];    
  var obj;  
  obj =  {
    'sub': sub,
    'msg':msg,
    'm': m,
    'n': n,
    'u': this.getCurrentUsr(),
    'fh': this.fnGetDateFormat(this.fnGetHoy(), "DMY") + " " + this.fnGetAhora(),
    'mailh': sessionStorage.getItem("csiMAILh"),
    'mailpto': sessionStorage.getItem("csiMAILp"),
    'mailus': sessionStorage.getItem("csiMAILus"),
    'mailssl': sessionStorage.getItem("csiMAILssl"),
    'mailtsl': sessionStorage.getItem("csiMAILtsl"),
    'mailpw': sessionStorage.getItem("csiMAILpw"),
    'sysn': this.sN,
    'syswe': this.sWe
  }   
  para.push(obj);
  return this.http.post<string>(this.urlMailLog, para[0], httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('sendMailLog'))
  );  
}

 fnGetBase64Image(img, width, height) {
  //console.log("getBase64");
  //console.log(img);
  var canvas = document.createElement("canvas");
  //--> Especificar el ancho deseado: (parametro width)
  canvas.width = width;
  canvas.height = height;
  //--> Para usar el tamaño del control (<img>) no hace falta parametro width:
  //canvas.width = img.width;
  //canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  //return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  return dataURL;
}

  
  getG():Observable<string> {
    return this.http.post<string>(this.urlG, '', httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getG'))
    );
  }

  
  fileExists(file):Observable<string> {
    var para = [];
    var obj =  {
      'file': file
    }
    para.push(obj);
    return this.http.post<string>(this.urlFileExists, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('fileExists'))
    );
  }

  getMail(a):Observable<string> {
    var para = [];
    var obj =  {
      'a': a
    }
    para.push(obj);
    return this.http.post<string>(this.urlMail, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMail'))
    );
  }
  
  getMenu():Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r': r
    }
    para.push(obj);
    return this.http.post<string>(this.urlMenu, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMenu'))
    );
  }

  isSameUsuarioPwd(usr, pwdMD5):Observable<string> {
    var para = [];
    var obj =  {
      'usr': usr,
      'pwdMD5': pwdMD5
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsSameUsuarioPwd, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isSameUsuarioPwd'))
    );
  }

  updUsuarioPwd(usr, pwdMD5):Observable<string> {
    var para = [];
    var obj =  {
      'usr': usr,
      'pwd': pwdMD5
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdUsuarioPwd, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updUsuarioPwd'))
    );
  }

  getUsrsAdmons(act):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'act': act
    }
    para.push(obj);
    return this.http.post<string>(this.urlUsrsAdmon, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getUsrsAdmons'))
    );
  }


  autMenu(menu:string):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r': r,
      'menu':menu
    }
    para.push(obj);
    return this.http.post<string>(this.urlAutMenu, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('utMenu'))
    );
  }

  getMenu2():Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r': r
    }
    para.push(obj);
    return this.http.post<string>(this.urlMenu2, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMenu2'))
    );
  }

  getMenUser():Observable<string> {
    var r = sessionStorage.getItem('gempGESusrR');
    var para = [];
    var obj =  {
      'r': r
    }
    para.push(obj);
    return this.http.post<string>(this.urlMenUser, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMenUser'))
    );
  }

  getAccXcep(mod):Observable<string> {
    var r = sessionStorage.getItem('gempGESusrR');
    var para = [];
    var obj =  {
      'r': r,
      'mod':mod
    }
    para.push(obj);
    return this.http.post<string>(this.urlAccXcep, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getAccXcep'))
    );
  }

  
  getVars(cve_var:string):Observable<string> {
    var para = [];
    var obj =  {
      'cve_var':cve_var
    }
    para.push(obj);
    return this.http.post<string>(this.urlGetVars, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVars'))
    );
  }

  setVar(cve_var:string, val:string):Observable<string> {
    var para = [];
    var obj =  {
      'cve_var':cve_var,
      'val':val
    }
    para.push(obj);
    return this.http.post<string>(this.urlSetVar, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('setVar'))
    );
  }
 
  getVarsUnidad(cve_var:string):Observable<string> {
    var para = [];
    var obj =  {
      'cve_var':cve_var
    }
    para.push(obj);
    return this.http.post<string>(this.urlGetVarsUnidad, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVarsUnidad'))
    );
  }

  setVarUnidad(cve_var:string, val:string):Observable<string> {
    var para = [];
    var obj =  {
      'cve_var':cve_var,
      'val':val
    }
    para.push(obj);
    return this.http.post<string>(this.urlSetVarUnidad, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('setVarUnidad'))
    );
  }

  altaFechaEspecial(fechaEsp:string):Observable<string> {
    var para = [];
    var obj =  {
      'usr': sessionStorage.getItem("csiBILLusr"),
      'fechaEsp':fechaEsp
    }
    para.push(obj);
    return this.http.post<string>(this.urlAltaFechaEspecial, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('altaFechaEspecial'))
    );
  }

  bajaFechaEspecial():Observable<string> {
    var para = [];
    var obj =  {
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlBajaFechaEspecial, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('bajaFechaEspecial'))
    );
  }

  ultFolio():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlUltFolio, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('ultFolio'))
    );
  }

  getFechaEspecial():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlGetFechaEspecial, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getFechaEspecial'))
    );
  }

  
  altaEnvioLog(idPersona:number):Observable<string> {
    var para = [];
    var obj =  {
      'usr': sessionStorage.getItem("csiBILLusr"),
      'idPersona':idPersona
    }
    para.push(obj);
    return this.http.post<string>(this.urlAltaEnvioLog, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('altaEnvioLog'))
    );
  }

  bajaEnvioLog():Observable<string> {
    var para = [];
    var obj =  {
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlBajaEnvioLog, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('bajaEnvioLog'))
    );
  }

  getEnvioLog():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlGetEnvioLog, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getEnvioLog'))
    );
  }

  getLogin(u,p):Observable<string> {
    var para = [];
    var obj =  {
      'u': u,
      'p': p
    }
    para.push(obj);
    //console.log(p);
    return this.http.post<string>(this.urlLogin, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getLogin'))
    );
  }

  getMsg(f,i):Observable<string> {
    var para = [];
    var obj =  {
      'id': i
    }
    para.push(obj);
    return this.http.post<string>(this.urlUsrExist, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMsg'))
    );
  }

  getFormatoImp(mod, act):Observable<string> {
    var para = [];
    var obj;
    obj =  {
      'mod' : mod,
      'act' : act
    }
    para.push(obj);
    return this.http.post<string>(this.urlFormatoImp, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getFormatoImp'))
    );
  }
  
  getFormStyles(ids, act):Observable<string> {
    var para = [];
    var obj;
    obj =  {
      'ids' : ids,
      'act' : act
    }
    para.push(obj);
    return this.http.post<string>(this.urlFormStyles, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getFormStyles'))
    );
  }
  
  getElemFormatoImp(idForm, tipo, act):Observable<string> {
    var para = [];
    var obj;
    obj =  {
      'idForm' : idForm,
      'tipo' : tipo,
      'act' : act
    }
    para.push(obj);
    return this.http.post<string>(this.urlElemFormatoImp, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getElemFormatoImp'))
    );
  }

  getRoles():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlRoles, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getRoles'))
    );
  }

  getRoles2():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlRoles2, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getRoles2'))
    );
  }

  getMonedas():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlMonedas, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMonedas'))
    );
  }
  
  updMoneda(id:number, act:boolean, tipo:string, valor:number):Observable<string> {
    var para = [];
    var obj =  {
      'id': id,
      'act': act,
      'tipo': tipo,
      'valor':valor
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdMoneda, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updMoneda'))
    );
  }

  insMoneda(nombre:string, act:boolean, tipo:string, valor:number):Observable<string> {
    var para = [];
    var obj =  {
      'act': act,
      'tipo': tipo,
      'nombre':nombre,
      'valor':valor
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsMoneda, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insMoneda'))
    );
  }

  getFormas(minId:number, maxId:number):Observable<string> {
    var para = [];
    var obj =  {
      'minId' : minId,
      'maxId' : maxId
    }
    para.push(obj);
    return this.http.post<string>(this.urlFormas, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getFormas'))
    );
  }

  updForma(id:number, act:boolean, descrip:string):Observable<string> {
    var para = [];
    var obj =  {
      'id': id,
      'act': act,
      'descrip': descrip
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdForma, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updForma'))
    );
  }

  insForma(forma:string, act:boolean, descrip:string):Observable<string> {
    var para = [];
    var obj =  {
      'forma': forma,
      'act': act,
      'descrip': descrip
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsForma, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insForma'))
    );
  }

  isFormaDup(strForma:string){
    var para = [];      
    var obj =  {
      'strForma': strForma
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsFormaDup, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isFormaDup'))
    );
  }

  getUbicaciones():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlUbicaciones, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getUbicaciones'))
    );
  }

  getUsuarios(txtRol:string):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r':r,
      'rol': txtRol
    }
    para.push(obj);
    return this.http.post<string>(this.urlUsuarios, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getUsuarios'))
    );
  }

  updUsuario(id:number, act:boolean, usr:string, nombre:string, email:string, idRol:number, idRolAct:number):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r':r,
      'id': id,
      'act':act,
      'usr':usr,
      'nombre': nombre,
      'email':email,
      'idRol':idRol,
      'idRolAct': idRolAct
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdUsuario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updUsuario'))
    );
  }

  insUsuario(act:boolean, usr:string, nombre:string, email:string, idRol:number):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r':r,
      'act':act,
      'usr':usr,
      'nombre': nombre,
      'email':email,
      'idRol':idRol
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsUsuario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insdUsuario'))
    );
  }

  isUsuarioDup(strUser:string){
    var para = [];      
    var obj =  {
      'strUser': strUser
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsUsuarioDup, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isUsuarioDup'))
    );
  }

  getProductos():Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'r':r
    }
    para.push(obj);
    return this.http.post<string>(this.urlProductos, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getProductos'))
    );
  }

  updProducto(idProd:number, idCat:number, relExp:number, descrip:string, subtot:number, arrRol:string, arrRolAct:string, arrDesc:string, arrDescAct:string, precioFut:number, fechaFut:string, act:boolean):Observable<string> {
    var para = [];      
    var obj =  {
      'idProd': idProd,
      'idCat': idCat,
      'relExp': relExp,
      'descrip': descrip,
      'subtot': subtot,
      'arrRol': arrRol,
      'arrRolAct': arrRolAct,
      'arrDesc': arrDesc,
      'arrDescAct': arrDescAct,
      'precioFut': precioFut,
      'fechaFut': fechaFut,
      'act': act
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdProducto, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updProducto'))
    );
  }

  insProducto(prod:string, idCat:number, relExp:number, descrip:string, act:boolean):Observable<string> {
    var para = [];      
    var obj =  {
      'prod': prod,
      'idCat': idCat,
      'relExp': relExp,
      'descrip': descrip,
      'act': act
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsProducto, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insProducto'))
    );
  }

  insRestoProducto(idProd:number, idCat:number, subtot:number, arrRol:string, arrRolAct:string, arrDesc:string, arrDescAct:string, precioFut:number, fechaFut:string):Observable<string> {
    var para = [];      
    var obj =  {
      'idProd': idProd,
      'idCat': idCat,
      'subtot': subtot,
      'arrRol': arrRol,
      'arrRolAct': arrRolAct,
      'arrDesc': arrDesc,
      'arrDescAct': arrDescAct,
      'precioFut': precioFut,
      'fechaFut': fechaFut
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsRestoProducto, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insRestoProducto'))
    );
  }

  isProductoDup(strProd:string){
    var para = [];      
    var obj =  {
      'strProd': strProd
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsProductoDup, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isProductoDup'))
    );
  }


  getDescuentos(primerDesc:number):Observable<string> {
    var para = [];
    var obj =  {
      'primerDesc' : primerDesc
    }
    para.push(obj);
    return this.http.post<string>(this.urlDescuentos, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getDescuentos'))
    );
  }

  isDescuentoDup(strDesc:string){
    var para = [];      
    var obj =  {
      'strDesc': strDesc
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsDescuentoDup, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isDescuentoDup'))
    );
  }

  getExposiciones(act:string  ):Observable<string> {
    var para = [];
    var obj =  {
      'act': act
    }
    para.push(obj);
    return this.http.post<string>(this.urlExposiciones, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getExposiciones'))
    );
  }

  updDescuento(id:number, act:boolean, descrip:string, mon_por:string, valor:number):Observable<string> {
    var para = [];
    var obj =  {
      'id': id,
      'act': act,
      'descrip': descrip,
      'mon_por': mon_por,
      'valor': valor
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdDescuento, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updDescuento'))
    );
  }

  insDescuento(descuento:string, act:boolean, descrip:string, mon_por:string, valor:number):Observable<string> {
    var para = [];
    var obj =  {
      'descuento': descuento,
      'act': act,
      'descrip': descrip,
      'mon_por': mon_por,
      'valor': valor
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsDescuento, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insDescuento'))
    );
  }

  getCategorias():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlCategorias, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getCategorias'))
    );
  }

  updCategoria(id:number, act:boolean, idGpo:number, grupo:string, descrip:string, etiqueta:string, etiqueta2:string):Observable<string> {
    var para = [];
    var obj =  {
      'id': id,
      'act': act,
      'idGpo': idGpo,
      'grupo': grupo,
      'descrip': descrip,
      'etiqueta': etiqueta,
      'etiqueta2': etiqueta2
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdCategoria, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updCategoria'))
    );
  }

  insCategoria(categoria:string, act:boolean, idGpo:number, grupo:string, descrip:string, etiqueta:string, etiqueta2:string):Observable<string> {
    var para = [];
    var obj =  {
      'categoria': categoria,
      'act': act,
      'grupo': grupo,
      'idGpo': idGpo,
      'descrip': descrip,
      'etiqueta': etiqueta,
      'etiqueta2': etiqueta2
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsCategoria, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insCategoria'))
    );
  }

  getGrupos():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlGrupos, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getGrupos'))
    );
  }

  getTipos():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlTipos, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getTipos'))
    );
  }


  getProdAct(idGpo:number):Observable<string> {
    var r = sessionStorage.getItem('csiBILLusrR');
    var para = [];
    var obj =  {
      'idGpo':idGpo,
      'r':r
    }
    para.push(obj);
    return this.http.post<string>(this.urlProdAct, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getProdAct'))
    );
  }

  getDescAct(idProd:number):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
    }
    para.push(obj);
    return this.http.post<string>(this.urlDescAct, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getDescAct'))
    );
  }

  getFormAct():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlFormAct, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getFormAct'))
    );
  }

  insTicket(idProd:number, idDesc:number, qty:number, sub:number, desc:number, total:number, idForm:number, fecEmi:string, horaEmi:string):Observable<string> {
    var para = [];
    if(fecEmi.length == 10){
      if(fecEmi.substr(5,3) == "/20")
        fecEmi = fecEmi.substr(6,4) + "/" + fecEmi.substr(3,2) + "/" + fecEmi.substr(0,2);
    }
    var obj =  {
      'idProd':idProd,
      'idDesc':idDesc,
      'qty':qty,
      'usr': sessionStorage.getItem("csiBILLusr"),
      //'taq': sessionStorage.getItem("csiBILLtaq"),
      'idForm': idForm,
      'sub':sub,
      'desc':desc,
      'total':total,
      'fecEmi':fecEmi,
      'horaEmi':horaEmi
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsTicket, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insTicket'))
    );
  }

  insTicketIngreso(idProd:number, idDesc:number, qty:number, arrSub:string, desc:number, arrTot:string, arrForm:string, fecEmi:string, horaEmi:string, arrRef:string):Observable<string> {
    var para = [];
    if(fecEmi.length == 10){
      if(fecEmi.substr(5,3) == "/20")
        fecEmi = fecEmi.substr(6,4) + "/" + fecEmi.substr(3,2) + "/" + fecEmi.substr(0,2);
    }
    var obj =  {
      'idProd':idProd,
      'idDesc':idDesc,
      'qty':qty,
      'usr': sessionStorage.getItem("csiBILLusr"),
      //'taq': sessionStorage.getItem("csiBILLtaq"),
      'arrForm': arrForm,
      'arrSub': arrSub,
      'desc':desc,
      'arrTot': arrTot,
      'fecEmi':fecEmi,
      'horaEmi':horaEmi,
      'arrRef':arrRef
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsTicketIngreso, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insTicketIngreso'))
    );
  }

  insEstadisticos(folio:string, qtyEstad:number, edad:number, hombres:boolean, mujeres:boolean, otro:string, otroQ:number, otro2:number):Observable<string> {
    var para = [];
    var obj =  {
      'folio':folio,
      'qtyEstad':qtyEstad,
      'edad':edad,
      'hombres':hombres,
      'mujeres':mujeres,
      'otro':otro,
      'otroQ':otroQ,
      'otro2':otro2
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsEstadisticos, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insEstadisticos'))
    );
  }

  
  canTicket(idTicket:number, motivo:string):Observable<string> {
    var para = [];
    var obj =  {
      'idTicket':idTicket,
      'motivo':motivo,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlCanTicket, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('canTicket'))
    );
  }
 
  canTickets(idTicket:number, idTicketFin:number, motivo:string):Observable<string> {
    var para = [];
    var obj =  {
      'idTicket':idTicket,
      'idTicketFin':idTicketFin,
      'motivo':motivo,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlCanTickets, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('canTickets'))
    );
  }

  updTicket(idTicket:number, forma:string):Observable<string> {
    var para = [];
    var obj =  {
      'idTicket':idTicket,
      'forma':forma,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdTicket, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updTicket'))
    );
  }
 
  updTickets(idTicket:number, idTicketFin:number, forma:string):Observable<string> {
    var para = [];
    var obj =  {
      'idTicket':idTicket,
      'idTicketFin':idTicketFin,
      'forma':forma,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdTickets, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updTickets'))
    );
  }

  ultTickets(idUser:string, idProd:string, fecIni:string, fecFin:string, idGpo:number, stat:string):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
      'idUser':idUser,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'rol': sessionStorage.getItem('csiBILLusrR'),
      'idGpo': idGpo,
      'stat':stat
    }
    para.push(obj);
    return this.http.post<string>(this.urlUltimosTickets, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('ultTickets'))
    );
  }

  ultTicketsGpo(idUser:string, idProd:string, fecIni:string, fecFin:string, idGpo:number, stat:string):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
      'idUser':idUser,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'rol': sessionStorage.getItem('csiBILLusrR'),
      'idGpo': idGpo,
      'stat':stat
    }
    para.push(obj);
    return this.http.post<string>(this.urlUltimosTicketsGpo, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('ultTicketsGpo'))
    );
  }

  notaVenta(idProd:string, fecIni:string, fecFin:string, idGpo:number, arrForma:string, stat:string):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'rol': sessionStorage.getItem('csiBILLusrR'),
      'idGpo': idGpo,
      'formas': arrForma,
      'stat':stat
    }
    para.push(obj);
    return this.http.post<string>(this.urlNotaVenta, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('notaVenta'))
    );
  }

  notaVentaGpo(idProd:string, fecIni:string, fecFin:string, idGpo:number, arrForma:string,  stat:string):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'rol': sessionStorage.getItem('csiBILLusrR'),
      'idGpo': idGpo,
      'formas': arrForma,
      'stat':stat
    }
    para.push(obj);
    return this.http.post<string>(this.urlNotaVentaGpo, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('notaVentaGpo'))
    );
  }

  cancelaciones(idUser:string, idProd:string, fecIni:string, fecFin:string, idGpo:number):Observable<string> {
    var para = [];
    var obj =  {
      'idProd':idProd,
      'idUser':idUser,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'rol': sessionStorage.getItem('csiBILLusrR'),
      'idGpo': idGpo,
    }
    para.push(obj);
    return this.http.post<string>(this.urlCancelaciones, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('cancelaciones'))
    );
  }

  afluencia(agrupar:string, fecIni:string, fecFin:string, idGpo:number):Observable<string> {
    var para = [];
    var obj =  {
      'agrupar':agrupar,
      'fecIni':fecIni,
      'fecFin':fecFin,
      'idGpo': idGpo,
    }
    para.push(obj);
    return this.http.post<string>(this.urlAfluencia, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('afluencia'))
    );
  }

  repIngreso(agrupar:string, fecIni:string, fecFin:string):Observable<string> {
    var para = [];
    var obj =  {
      'agrupar':agrupar,
      'fecIni':fecIni,
      'fecFin':fecFin,
    }
    para.push(obj);
    return this.http.post<string>(this.urlRepIngreso, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('repIngreso'))
    );
  }

  repIngresoDet(agrupar:string, fecIni:string, fecFin:string):Observable<string> {
    var para = [];
    var obj =  {
      'agrupar':agrupar,
      'fecIni':fecIni,
      'fecFin':fecFin,
    }
    para.push(obj);
    return this.http.post<string>(this.urlRepIngresoDet, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('repIngresoDet'))
    );
  }

  getInfoReciboOrigen(folioIni:number, folioFin:number):Observable<string> {
    var para = [];
    var obj =  {
      'folioIni':folioIni,
      'folioFin':folioFin,
    }
    para.push(obj);
    return this.http.post<string>(this.urlInfoReciboOrigen, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getInfoReciboOrigen'))
    );
  }

  getMeta(idGpo:number, mes:number, esTrimes:boolean):Observable<string> {
    var para = [];
    var obj =  {
      'idGpo': idGpo,
      'mes': mes,
      'esTrimes': esTrimes
    }
    para.push(obj);
    return this.http.post<string>(this.urlMeta, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getMeta'))
    );
  }

  insMeta(fecha:Date, idGpo:string, act:string, asis:string):Observable<string> {
    var para = [];
    var obj =  {
      'fecha': fecha,
      'idGpo': idGpo,
      'act': act,
      'asis': asis,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsMeta, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insMeta'))
    );
  }

  updMeta(fecha:Date, idGpo:number, act:number, asis:number):Observable<string> {
    var para = [];
    var obj =  {
      'fecha': fecha,
      'idGpo': idGpo,
      'act': act,
      'asis': asis,
      'usr':sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdMeta, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updMeta'))
    );
  }

  getCorte(fec:string):Observable<string> {
    var para = [];
    var obj =  {
      'fec': fec,
      'usr': sessionStorage.getItem("csiBILLusr")
    }
    para.push(obj);
    return this.http.post<string>(this.urlCorte, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getCorte'))
    );
  }

  getArqueo(fec:string, idPersonas:string):Observable<string> {
    var para = [];
    var obj =  {
      'fec': fec,
      'idPersonas': idPersonas
    }
    para.push(obj);
    return this.http.post<string>(this.urlArqueo, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getArqueo'))
    );
  }

  sisc(idGpo:number, fecIni:string, fecFin:string, duplicar:boolean, verDetalle:boolean):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni':fecIni,
      'fecFin':fecFin,
      'idGpo': idGpo,
      'duplicar': duplicar,
      'verDetalle': verDetalle
    }
    para.push(obj);
    return this.http.post<string>(this.urlSISC, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('sisc'))
    );
  }

  siscDiario(idGpo:number, fecIni:string, fecFin:string):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni':fecIni,
      'fecFin':fecFin,
      'idGpo': idGpo
    }
    para.push(obj);
    return this.http.post<string>(this.urlSISCDiario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('siscDiario'))
    );
  }

  sisc2(idGpo:number, fecIni:string, fecFin:string, verDetalle:boolean):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni':fecIni,
      'fecFin':fecFin,
      'idGpo': idGpo,
      'verDetalle': verDetalle
    }
    para.push(obj);
    return this.http.post<string>(this.urlSISC2, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('sisc2'))
    );
  }

  getDestinatario(idPersona:number):Observable<string> {
    var para = [];
    var obj =  {
      'idPersona': idPersona,
    }
    para.push(obj);
    return this.http.post<string>(this.urlDestinatario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getDestinatario'))
    );
  }
  
  getOrigenes(act:string):Observable<string> {
    var para = [];
    var obj =  {
      'act': act,
    }
    para.push(obj);
    return this.http.post<string>(this.urlOrigenes, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getOrigenes'))
    );
  }

  getJefe():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlJefe, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getJefe'))
    );
  }

  existeUsrJefe():Observable<string> {
    var para = [];
    var obj =  {
    }
    para.push(obj);
    return this.http.post<string>(this.urlExisteUsrJefe, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('existeUsrJefe'))
    );
  }

  insRecibo(idGpo, cveGpo, folioIni, folioFin, fecha):Observable<string> {
    var para = [];
    if(fecha.length == 10){
      if(fecha.substr(5,3) == "/20")
      fecha = fecha.substr(6,4) + "/" + fecha.substr(3,2) + "/" + fecha.substr(0,2);
    }
    var obj =  {
      'idGpo': idGpo,
      'cveGpo': cveGpo,
      'folioIni': folioIni,
      'folioFin': folioFin,
      'fecha': fecha
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsRecibo, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insRecibo'))
    );
  }

  validaFolio(f, ff, t, fec, h, u):Observable<string> {
    var para = [];
    var obj =  {
      'f': f,
      'ff': ff,
      't': t,
      'fec': fec,
      'h': h,
      'u':u
    }
    para.push(obj);
    return this.http.post<string>(this.urlValidaFolio, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('validaFolio'))
    );
  }

  insEntradaUbi(hoy, h, idUbi, msg, off, id, f, ff):Observable<string> {
    var para = [];
    var obj =  {
      'hoy': hoy,
      'h': h,
      'idUbi': idUbi,
      'msg': msg,
      'off': off,
      'id':id,
      'f': f,
      'ff': ff
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsEntradaUbi, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insEntradaUbi'))
    );
  }

  
  getEntradasDia(fecIni, fecFin, ubi, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'ubi': ubi,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlEntradasDia, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getEntradasDia'))
    );
  }

  getEntradasMes(fecIni, fecFin, ubi, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'ubi': ubi,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlEntradasMes, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getEntradasMes'))
    );
  }

  getEntradasDiaSem(fecIni, fecFin, ubi, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'ubi': ubi,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlEntradasDiaSem, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getEntradasDiaSem'))
    );
  }

  getEntradasHorario(fecIni, fecFin, ubi, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'ubi': ubi,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlEntradasHorario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getEntradasHorario'))
    );
  }

  getVentasDia(fecIni, fecFin, gpo, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'gpo': gpo,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlVentasDia, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVentasDia'))
    );
  }

  getVentasMes(fecIni, fecFin, gpo, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'gpo': gpo,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlVentasMes, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVentasMes'))
    );
  }

  getVentasDiaSem(fecIni, fecFin, gpo, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'gpo': gpo,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlVentasDiaSem, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVentasDiaSem'))
    );
  }

  getVentasHorario(fecIni, fecFin, gpo, cat):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
      'gpo': gpo,
      'cat': cat
    }
    para.push(obj);
    return this.http.post<string>(this.urlVentasHorario, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getVentasHorario'))
    );
  }


  getPres_Arbol(lev, act, arrExcep):Observable<string> {
    var para = [];
    var obj =  {
      'lev': lev,
      'act': act,
      'arrExcep': arrExcep
    }
    para.push(obj);
    return this.http.post<string>(this.urlPres_Arbol, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getPres_Arbol'))
    );
  }

  updConcepto(niv:number, id:number, act:boolean, concep:string, etiq:string, nota:string, preCarga:string):Observable<string> {
    var para = [];      
    var obj =  {
      'niv': niv,
      'id': id,
      'act': act,
      'concep': concep,
      'etiq': etiq,
      'nota': nota,
      'preCarga': preCarga
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdConcepto, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updConcepto'))
    );
  }
  
  insConcepto(niv:number, act:boolean, concep:string, etiq:string, nota:string, preCarga:string):Observable<string> {
    var para = [];      
    var obj =  {
      'niv': niv,
      'act': act,
      'concep': concep,
      'etiq': etiq,
      'nota': nota,
      'preCarga': preCarga
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsConcpeto, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insConcepto'))
    );
  }

  isConceptoDup(strConcepto:string){
    var para = [];      
    var obj =  {
      'strConcepto': strConcepto
    }
    para.push(obj);
    return this.http.post<string>(this.urlIsConceptoDup, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('isConceptoDup'))
    );
  }


  getPres_UltMov(lim, idConSub, idDet):Observable<string> {
    var para = [];
    var obj =  {
      'lim': lim,
      'idConSub': idConSub,
      'idDet': idDet,
    }
    para.push(obj);
    return this.http.post<string>(this.urlPres_UltMov, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getPres_UltMov'))
    );
  }

  insPres_Mov(idConSub, idDet, monto, fecha, ref, concep):Observable<string> {
    var para = [];
    var obj =  {
      'idConSub': idConSub,
      'idDet': idDet,
      'monto': monto,
      'fecha': fecha,
      'ref': ref,
      'concep': concep
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsPres_Mov, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insPres_Mov'))
    );
  }

  
  insNotaVenta(folioSAE, folio, monto, archivo):Observable<string> {
    var para = [];
    var obj =  {
      'folioSAE': folioSAE,
      'folio': folio,
      'monto': monto,
      'archivo': archivo
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsNotaVenta, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insNotaVenta'))
    );
  }

  updTicketNV(folioSAE, folio, monto, archivo):Observable<string> {
    var para = [];
    var obj =  {
      'folioSAE': folioSAE,
      'folio': folio,
      'monto': monto,
      'archivo': archivo
    }
    para.push(obj);
    return this.http.post<string>(this.urlUpdTicketNV, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('updTicketNV'))
    );
  }

  createTxtFile(string,filename) {
    console.log(string);
    //var blob=new Blob(["hello worlD!"],{type:"text/plain;charset=utf8"});
    var blob=new Blob([string],{type:"text/plain;charset=utf8"});
  FileSaver.saveAs(blob,filename);
/*
    var para = [];
    var obj =  {
      'prefijo': prefijo
    }
    para.push(obj);
    return this.http.post<string>(this.urlMaxFolioSAE, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('maxFolioSAE'))
    );
    */
  }


  maxFolioSAE(prefijo):Observable<string> {
    var para = [];
    var obj =  {
      'prefijo': prefijo
    }
    para.push(obj);
    return this.http.post<string>(this.urlMaxFolioSAE, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('maxFolioSAE'))
    );
  }

  getPres_Totales(fecIni, fecFin):Observable<string> {
    var para = [];
    var obj =  {
      'fecIni': fecIni,
      'fecFin': fecFin,
    }
    para.push(obj);
    return this.http.post<string>(this.urlPres_Totales, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('getPres_Totales'))
    );
  }

  insEvAudioIARegistro(nom, ap, fecNac, nomTut, apTut, mail, otro):Observable<string> {
    var para = [];
    var obj =  {
      'nom': nom,
      'ap': ap,
      'fecNac': fecNac,
      'nomTut': nomTut,
      'apTut': apTut,
      'mail': mail,
      'otro': otro
    }
    para.push(obj);
    return this.http.post<string>(this.urlInsEvAudioIARegistro, para[0], httpOptions).pipe(
      tap((data: any) => this.log(`${data}`)),
      catchError(this.handleError<string>('insEvAudioIARegistro'))
    );
  }

  //--> CLOUDFLARE
cf_insEvAudioIARegistro(nom, ap, fecNac, nomTut, apTut, mail, otro):Observable<string> {
  var para = [];
  var obj =  {
    'nom': nom,
    'ap': ap,
    'fecNac': fecNac,
    'nomTut': nomTut,
    'apTut': apTut,
    'mail': mail,
    'otro': otro
  }
  para.push(obj);
  return this.http.get<string>(this.url_CF_InsEvAudioIARegistro,  httpOptions).pipe(
    tap((data: any) => this.log(`${data}`)),
    catchError(this.handleError<string>('cf_insEvAudioIARegistro'))
  );
}


  insLog(mod, op, data, err):Observable<string> {
    var para = [];
    var obj =  {
      'mod': mod,
      'op': op,
      'data': data,
      'usr': sessionStorage.getItem("csiBILLusr"),
      'err': err
    }
    para.push(obj);
    return this.http.post<string>(this.urlLog, para[0], httpOptions).pipe(
      tap((data: any) => ''),
      catchError(this.handleError<string>('insLog'))
    );
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
private handleError<T> (operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {

    // TODO: send the error to remote logging infrastructure
    console.error(error); // log to console instead
    this.insLog('DS', 'ERROR', operation, error)
    // TODO: better job of transforming error for user consumption
    this.log(`${operation} failed: ${error.message}`);

    // Let the app keep running by returning an empty result.
    return of(result as T);
  };
}

/** Log a DataService message */
private log(message: any) {
  //console.log("LOG:");
  //console.log(message);
  var m = ""
  if (message.length > 500)
    m = message.substr(0,497) + "...";
  else
    m = message;
  //this.insLog('DS', 'LOG', m, '').subscribe();  //--> Demasiados logs!!!
}

}
